<template>
  <div class="min-body">
      <!-- banner -->
      <banner :banner-list="bannerList"></banner>
      <!-- 公司动态 -->
    <div style="display: none;" class="news-container">
      <!-- 标题区域 -->
      <div class="news-header">
        <h2 class="news-title">{{ $t('news.banner.title') }}</h2>
      </div>
      <!-- 新闻列表 -->
      <div class="news-list">
        <div class="news-card" v-for="(item, index) in newsList" :key="index">
          <div class="news-card-left">
            <div class="date-block">
              <span class="day">{{ item.date.split('-')[2] }}</span>
              <span class="slash">/</span>
              <span class="year-month">
                <span>{{ item.date.split('-')[0] }}</span>
                <span>{{ item.date.split('-')[1] }}</span>
            </span>
            </div>
            <div class="content-block">
              <h3 class="title">{{ $t(item.titleKey) }}</h3>
              <p class="desc">{{ $t(item.descKey) }}</p>
            </div>
          </div>

          <div class="image-placeholder">
            <img :src="item.image">
          </div>
        </div>
      </div>
    </div>
    <h1 style="width: 100%;text-align: center;">{{ $t('common.noNews') }}</h1>
    <!-- Footer -->
    <Footer style="margin-top: 80px;"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import banner from "@/views/Home/components/Banner/banner.vue";

export default {
  name: "News",
  components: {banner, Footer},
  data() {
    return {
      bannerList: [
        {
          titleKey: 'news.banner.title',
          descKey: 'news.banner.desc',
          btnText: '',
          image: require('@/assets/img/CompanyNews/banner/CompanyNews-banner.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.aiEngine.tags'
        }
      ],
      newsList: [
        {
          id: 1,
          date: "2026-04-19",
          titleKey: 'news.list.item1.title',
          descKey: 'news.list.item1.desc',
          link: "/news/1",
          image: require('@/assets/img/CompanyNews/new-img01.webp')
        },
        {
          id: 2,
          date: "2026-04-10",
          titleKey: 'news.list.item2.title',
          descKey: 'news.list.item2.desc',
          link: "/news/2",
          image: require('@/assets/img/CompanyNews/new-img02.webp')
        },
        {
          id: 3,
          date: "2026-03-15",
          titleKey: 'news.list.item3.title',
          descKey: 'news.list.item3.desc',
          link: "/news/3",
          image: require('@/assets/img/CompanyNews/new-img03.webp')
        },
        {
          id: 4,
          date: "2026-02-28",
          titleKey: 'news.list.item4.title',
          descKey: 'news.list.item4.desc',
          link: "/news/4",
          image: require('@/assets/img/CompanyNews/new-img04.webp')
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    })
  },
  methods: {
    goDetail(link) {
      this.$router.push(link);
    }
  }
};
</script>

<style scoped>
.news-section {
  padding: 120px 0 0 0;
  background-color: #ffffff;
}
.news-container {
  width: calc(100% - 26vh);

  margin: 120px auto;
  padding: 0 20px;
}

.news-header {
  text-align: center;
  margin-bottom: 120px;
}
.news-title {
  text-align: left;
  font-size: 36px;
  font-weight: 600;
  color: #1d2129;
  margin: 0 0 12px 0;
}
.news-desc {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.news-card {
  display: flex;
  align-items: center;
  height: 18vh;
  padding: 1.6vh 2vh;
}
.news-card:hover {
  transform: translateY(-4px);
}
.news-card-left{
  width: calc(100% - 34vh);
  height: 18vh;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F0F0F0;
  margin-right:1.5vh;
}
.date-block {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: #333;
  margin-right: 3vh;
}

.day {
  font-size: 2vw;
  font-weight: 600;
  line-height: 1;
  color: #595959;
}

.slash {
  font-size: 1.5vw;
  color: #999;
  margin: 12px 4px 0 2px;
}

.year-month {
  display: flex;
  flex-direction: column;
  font-size: 22px;
  color: #999;
  line-height: 1.2;
  margin-top: 8px;
}

.content-block {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  h3, p{
    margin: 0;
  }
}

.title {
  font-size: 32px;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}

.desc {
  font-size: 20px;
  color: #666;
  line-height: 1.6;
}

.image-placeholder {
  flex-shrink: 0;
  width: 32vh;
  height: 18vh;
  background: linear-gradient(135deg, #e8f3ff 0%, #d6eaff 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #88b8ff;
  font-size: 14px;
  >img{
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 1200px) {
  .title {
    font-size: 32px;
  }
  .desc {
    font-size: 20px;
  }
  .image-placeholder {
    width: 260px;
    height: 130px;
  }
}

@media (max-width: 900px) {
  .news-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .image-placeholder {
    width: 100%;
    max-width: 320px;
    margin-top: 16px;
  }
}
</style>